// hooks/useLot.ts
import { useCallback, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import { BookingGetLotQuery, BookingGetLotQueryVariables } from 'parkdepot-shared/gql/graphql'
import { LotContext } from '../../../context/LotContext/lot.context'
import { GET_LOT_WITH_ID } from '../../../graphql/queries/getLotWithId.query'
import { homeRoute } from '../../Home/route.const'
import { generateLotWithIdQueryOptions } from '../utils/generateLotWithIdQueryOptions.utils'
import { Lot } from '../../../types/lot.interface'

export const useLot = (lotId: string) => {
    const { lot, modifyAndSetLot } = useContext(LotContext)
    const history = useHistory()

    const [getLotWithId, { data: lotData, error }] = useLazyQuery<BookingGetLotQuery, BookingGetLotQueryVariables>(
        GET_LOT_WITH_ID
    )

    const memoizedModifyAndSetLot = useCallback(modifyAndSetLot, [])

    const navigateToHome = useCallback(() => {
        history.push(homeRoute())
    }, [history])

    useEffect(() => {
        if (!lot) {
            getLotWithId(generateLotWithIdQueryOptions(lotId))
        }
    }, [lot, lotId, getLotWithId])

    useEffect(() => {
        if (lotData) {
            if (lotData.booking_get_lot === null) {
                navigateToHome()
            } else {
                memoizedModifyAndSetLot(lotData.booking_get_lot as unknown as Lot)
            }
        }
    }, [lotData, memoizedModifyAndSetLot, navigateToHome])

    return { lot, error }
}
